// File: store/marvel.js
// Purpose: State store for the Marvel view.
// Notes: Holds fetched MCU movie list used by the view to group by phase.
export default {
  header: "Marvel Cinematic Universe",
  view: "marvel",
  marvel: [],
  doomsday: null,
  news: []
};
